import { FloatingPanels } from "orcs-design-system";
import React, { useMemo } from "react";
import { Panel } from "reactflow";
import { isEmpty, some } from "lodash";
import { useOrgChartContext } from "src/components/OrgChart/context/OrgChartContext";
import { ACTION_TYPES } from "../../context/actionTypes";
import ViewOptions from "./components/ViewOptions";
import Properties from "./components/Properties";
import Legend from "./components/Legend";
import { PANEL_ID } from "./const";
import SelectedPerson from "./components/SelectedPerson";

const panels = [
  {
    id: PANEL_ID.legend,
    iconName: "palette",
    title: "Legend",
    content: <Legend />,
    isVisible: () => true,
  },
  {
    id: PANEL_ID.viewOptions,
    iconName: "cog",
    title: "View Options",
    content: <ViewOptions />,
    isVisible({ state } = {}) {
      const expandedTeams = state?.expandedNodes?.map(
        (nodeId) => state?.loadedTeams[nodeId]
      );

      return some(expandedTeams, (t) => t.directMemberCount > 0);
    },
  },
  {
    id: PANEL_ID.properties,
    iconName: "filter",
    title: "Properties",
    content: <Properties />,
    isVisible: ({ state }) => {
      return !isEmpty(state?.loadedTeams) || !isEmpty(state?.loadedMembers);
    },
  },
  {
    id: PANEL_ID.selectedPerson,
    iconName: "info-circle",
    title: "Details",
    content: <SelectedPerson />,
    isVisible: () => true,
  },
];

const OrgChartPanel = () => {
  const context = useOrgChartContext();

  const handleClick = (panelId) => {
    context?.dispatch({
      type: ACTION_TYPES.UPDATE_EXPANDED_PANEL,
      payload: {
        panelId,
      },
    });
  };

  const filteredPanels = useMemo(() => {
    return panels
      .filter((panel) => panel.isVisible(context))
      .map((panel) => {
        return {
          ...panel,
          expanded: context?.state?.expandedPanel?.panelId === panel.id,
        };
      });
  }, [context]);

  return (
    <Panel position="top-right">
      <FloatingPanels
        onClick={handleClick}
        panels={filteredPanels}
        containerHeight={700}
        position={{
          right: 0,
          top: 0,
        }}
      />
    </Panel>
  );
};

export default OrgChartPanel;
